import { render, staticRenderFns } from "./SettingModal.vue?vue&type=template&id=5a58e2a9&scoped=true"
import script from "./SettingModal.vue?vue&type=script&lang=js"
export * from "./SettingModal.vue?vue&type=script&lang=js"
import style0 from "./SettingModal.vue?vue&type=style&index=0&id=5a58e2a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a58e2a9",
  null
  
)

export default component.exports